import { SetSelectedTagsAction } from '../actions';
import { loadPilots } from '../loadPilots';
import { call } from 'redux-saga/effects';
import { loadMaintenance } from '../loadMaintenance';

export function* watchTagsWorker(action: SetSelectedTagsAction) {
  yield call(loadPilots);
  yield call(loadMaintenance);
}
